/**
 * Formats any string into DD/MM/YYYY from its digits, progressively:
 * '3105' -> '31/05', '31052026' -> '31/05/2026'. Extra digits are dropped.
 */
export const formatDateString = (value: string): string => {
  const digits = value.replace(/\D/g, '').slice(0, 8);

  if (digits.length <= 2) return digits;
  if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`;
  return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
};
